import { lazy } from 'react';
const QuestionnaireRoutes = [
    {
        label: '公开问卷',
        key: 'public',
        show: true,
        path: '/public/questionnaire-public',
        element: lazy(() => import('@/page/Questionnaire/QuestionSheetPublic'))
    },
    {
        label: '公开问卷结果',
        key: 'public-result',
        show: true,
        path: '/public/questionnaire-public-result',
        element: lazy(() => import('@/page/Questionnaire/QuestionResultPublic'))
    }
];
export default QuestionnaireRoutes;
